module.exports = __webpack_public_path__ + "img/parent.82b8ae32.png";